var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import * as React from 'react';
import { Dropdown } from './dropdownTeam';
import styles from './person.module.scss';
export class Person extends React.PureComponent {
    render() {
        const _a = this.props, { children, className, onActionsClick, previewDropdownButton, avatar, dropdown } = _a, otherProps = __rest(_a, ["children", "className", "onActionsClick", "previewDropdownButton", "avatar", "dropdown"]);
        const rootClass = classnames({
            [styles.person]: true,
        }, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [children, _jsxs("div", Object.assign({ className: styles.pullRight }, { children: [!!avatar && _jsx("div", Object.assign({ className: styles.avatarWrap }, { children: avatar })), !!previewDropdownButton && (_jsx("div", Object.assign({ className: styles.previewDropdownButton }, { children: previewDropdownButton }))), _jsx(Dropdown, { children: dropdown })] }))] })));
    }
}
Person.displayName = 'Person';
